module.exports = __webpack_public_path__ + "statics/img/LogisticsPartners-2.d672734e.png";